import type { SVGProps } from 'react';

import { PARTNER_BRANDS } from './partnerBrands';
import type { LogoVariant, PartnerId } from './types';

export type PartnerLogoProps = SVGProps<SVGSVGElement> & {
  partnerId: PartnerId;
  variant: LogoVariant;
};

const PartnerLogo = ({ partnerId, variant, ...svgProps }: PartnerLogoProps) => {
  const Logo = PARTNER_BRANDS[partnerId][variant];
  return <Logo {...svgProps} />;
};

export default PartnerLogo;
